export class User {

    public id: number;
    public lastname: string;
    public firstname: string;
    public email: string;
    public password: string;
    public jwtToken: string;
}
